import { actions as photoActions } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpDispatch, PhotoPrintsPdpThunk } from '@ff-scene-plugins/photo-prints-redux/store';
import cuid from 'cuid';
import { selectVariantByPaperAndSize } from '../_redux-variants';
import { addGroup } from './addGroup';

export type ChangePhotoVariantMethod = 'copy' | 'move';

export const changePhotoVariant = (
    paperId: string,
    sizeId: string,
    photoId: string,
    method: ChangePhotoVariantMethod,
    forceNewGroup: boolean = false
): PhotoPrintsPdpThunk => {
    return (dispatch, getState) => {

        const state = getState();
        const variant = selectVariantByPaperAndSize(state, paperId, sizeId)!;

        const groups = Object.values(state.project.groups.entities);
        const group = groups.find(g => g!.variantId === variant.id);
        const groupId = forceNewGroup || !group
            ? createNewGroup(variant.id, dispatch)
            : group.id;

        if (method === 'move') {
            dispatch(photoActions.move({ photoId: photoId, groupId: groupId }));
        } else {
            dispatch(photoActions.copy({ photoId: photoId, groupId: groupId }));
        }
    };
};

const createNewGroup = (variantId: string, dispatch: PhotoPrintsPdpDispatch) => {

    const groupId = cuid();

    dispatch(addGroup({
        id: groupId,
        variantId: variantId,
        amountInQueue: 0
    }));

    return groupId;
};